module.exports = __webpack_public_path__ + "img/9788954618762.8513b17d.jpg";